/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type UpdateIngressRequestBody = {
  enabled?: boolean | undefined;
  hostname?: string | undefined;
  identityRequired?: boolean | undefined;
};

/** @internal */
export type UpdateIngressRequestBody$Outbound = {
  enabled?: boolean | undefined;
  hostname?: string | undefined;
  identity_required?: boolean | undefined;
};

/** @internal */
export const UpdateIngressRequestBody$outboundSchema: z.ZodMiniType<
  UpdateIngressRequestBody$Outbound,
  UpdateIngressRequestBody
> = z.pipe(
  z.object({
    enabled: z.optional(z.boolean()),
    hostname: z.optional(z.string()),
    identityRequired: z.optional(z.boolean()),
  }),
  z.transform((v) => {
    return remap$(v, {
      identityRequired: "identity_required",
    });
  }),
);

export function updateIngressRequestBodyToJSON(
  updateIngressRequestBody: UpdateIngressRequestBody,
): string {
  return JSON.stringify(
    UpdateIngressRequestBody$outboundSchema.parse(updateIngressRequestBody),
  );
}
